<template>
	<fieldset class="fieldset">
		<div class="form-row two-columns">
			<field-box name="property_car[brand]" :label="$t('forms.brand')" type="text" :value="data?.brand" :disabled="disabled" :has-error="errors?.['property_car.brand']?.length"/>
			<field-box name="property_car[model]" :label="$t('forms.model')" type="text" :value="data?.model" :disabled="disabled" :has-error="errors?.['property_car.model']?.length"/>
		</div>
		<div class="form-row two-columns">
			<field-box name="property_car[production_year]" :label="$t('forms.production_year')" type="number" :value="data?.production_year" :disabled="disabled" :has-error="errors?.['property_car.production_year']?.length"/>
			<field-box name="property_car[registration_date]" :label="$t('forms.registration_date')" type="date" :value="data?.registration_date" :disabled="disabled" :has-error="errors?.['property_car.registration_date']?.length"/>
		</div>
		<div class="form-row two-columns">
			<field-box name="property_car[fuel_type]" :label="$t('forms.fuel_type')" type="select" :options="fuelTypeOptions" :disabled="disabled" :has-error="errors?.['property_car.fuel_type']?.length"/>
			<field-box name="property_car[transmission]" :label="$t('forms.transmission')" type="select" :options="transmissionOptions" :disabled="disabled" :has-error="errors?.['property_car.transmission']?.length"/>
		</div>
		<div class="form-row two-columns">
			<field-box name="property_car[doors]" :label="$t('forms.doors')" type="number" :value="data?.doors" :disabled="disabled" :has-error="errors?.['property_car.doors']?.length"/>
			<field-box name="property_car[seats]" :label="$t('forms.seats')" type="number" :value="data?.seats" :disabled="disabled" :has-error="errors?.['property_car.seats']?.length"/>
		</div>
		<div class="form-row two-columns">
			<field-box name="property_car[accident]" :label="$t('forms.accident')" type="select" :options="accidentOptions" :disabled="disabled" :has-error="errors?.['property_car.accident']?.length"/>
			<field-box name="property_car[vehicle_type]" :label="$t('forms.vehicle_type')" type="select" :options="vehicleTypeOptions" :disabled="disabled" :has-error="errors?.['property_car.vehicle_type']?.length"/>
		</div>
		<div class="form-row two-columns">
			<field-box name="property_car[mileage]" :label="$t('forms.mileage')" type="number" :value="data?.mileage" :disabled="disabled" :has-error="errors?.['property_car.mileage']?.length"/>
			<field-box name="property_car[weight]" :label="$t('forms.weight')" type="number" :value="data?.weight" :disabled="disabled" :has-error="errors?.['property_car.weight']?.length"/>
		</div>
		<div class="form-row two-columns">
			<field-box name="property_car[engine_capacity]" :label="$t('forms.engine_capacity')" type="number" :value="data?.engine_capacity" :disabled="disabled" :has-error="errors?.['property_car.engine_capacity']?.length"/>
			<field-box name="property_car[license_plate]" :label="$t('forms.license_plate')" type="text" :value="data?.license_plate" :disabled="disabled" :has-error="errors?.['property_car.license_plate']?.length"/>
		</div>
		<div class="form-row">
			<field-box name="property_car[vin]" :label="$t('forms.vin')" type="text" :value="data?.vin" :disabled="disabled" :has-error="errors?.['property_car.vin']?.length"/>
		</div>
	</fieldset>
</template>

<script>

import DefaultFieldBox from "@/components/form-fields/DefaultFieldBox.vue";
import FieldBox from "@/components/form-fields/FieldBox.vue";

export default {
	name: "PropertyCarFieldset",
	props: ['data', 'disabled', 'errors'],
	components: {
		DefaultFieldBox,
		FieldBox
	},
	computed: {
		vehicleTypeOptions() {
			let options = [
				{
					value: '',
					title: this.$t('forms.choose')
				},
				{
					value: 'passenger',
					title: this.$t('forms.vehicle_type_passenger')
				},
				{
					value: 'cargo',
					title: this.$t('forms.vehicle_type_cargo')
				},
				{
					value: 'motorcycle',
					title: this.$t('forms.vehicle_type_motorcycle')
				}
			];

			if(this.data){
				options.forEach(item => {
					if (item.value === this.data?.vehicle_type) {
						item.selected = true;
					}
				});
			}

			return options;
		},
		accidentOptions(){
			let options = [
				{
					value: '',
					title: this.$t('forms.choose')
				},
				{
					value: 1,
					title: this.$t('general.yes')
				},
				{
					value: 0,
					title: this.$t('general.no')
				},
			];

			if(this.data){
				options.forEach(item => {
					if (item.value === this.data?.accident) {
						item.selected = true;
					}
				});
			}

			return options;
		},
		transmissionOptions(){
			let options = [
				{
					value: '',
					title: this.$t('forms.choose')
				},
				{
					value: 'automatic',
					title: this.$t('forms.transmission_automatic')
				},
				{
					value: 'manual',
					title: this.$t('forms.transmission_manual')
				},
			];

			if(this.data){
				options.forEach(item => {
					if (item.value === this.data?.transmission) {
						item.selected = true;
					}
				});
			}

			return options;
		},
		fuelTypeOptions(){
			let options = [
				{
					value: '',
					title: this.$t('forms.choose')
				},
				{
					value: 'diesel',
					title: this.$t('forms.fuel_type_diesel')
				},
				{
					value: 'octane',
					title: this.$t('forms.fuel_type_octane')
				},
				{
					value: 'gas',
					title: this.$t('forms.fuel_type_gas')
				},
				{
					value: 'petrol',
					title: this.$t('forms.fuel_type_petrol')
				},
				{
					value: 'hybrid',
					title: this.$t('forms.fuel_type_hybrid')
				},
				{
					value: 'electric',
					title: this.$t('forms.fuel_type_electric')
				}
			];

			if(this.data){
				options.forEach(item => {
					if (item.value === this.data?.fuel_type) {
						item.selected = true;
					}
				});
			}

			return options;
		}
	}
}
</script>

<style scoped lang="scss">
fieldset {
	margin: 0;
	padding: 0;
	margin-inline: 0;
	padding-block: 0;
	padding-inline: 0;
	border: none;
}


.form-row {
	margin-bottom: 15px;

	&:last-child {
		margin-bottom: 0;
	}

	&.two-columns {
		display: flex;
		justify-content: space-between;
		flex-direction: row;

		.field-box {
			width: calc(50% - 8px);
		}
	}
}

@media($mobileS) {
	.form-row {
		margin-bottom: 10px;

		&.two-columns {
			flex-direction: column;

			.field-box {
				width: 100%;
				margin-bottom: 10px;

				&:last-child {
					margin-bottom: 0;
				}
			}
		}
	}
}

</style>